var React         = require('react');
var ReactDOM      = require('react-dom');
var $             = require('jquery');
var _             = require('lodash');

var animate       = require('patternity/lib/utilities/animate.js');
var ChallengeCardImage = require('./challenge_card_image.jsx');
var ChallengeCardOptions = require('./challenge_card_options.jsx');
var Card          = require('patternity/lib/cards/card');
var cn = require('classnames')

var ChallengeCard = React.createClass({
  propTypes : {
    id : React.PropTypes.string,
    rewriteLook: React.PropTypes.bool
  },

  getDefaultProps : function(){
    return {
      id : ""
    };
  },

  getInitialState: function() {
    return {
      maxLines: 3
    };
  },

  componentDidMount : function(){
    this._addWindowResizeEvent();
    this._adjustDescriptionHeight();
  },


  componentWillUnmount: function(){
    this._removeWindowResizeEvent();
  },

  render: function () {
    return (
      <div ref="challengeCard" className={cn({
        "challenge-card card": true,
        "challenge-card__rewrite": this.props.rewriteLook
      })}
      id={this.props.id}>
        <Card ref="card">
          {this._addChildren()}
        </Card>
      </div>
    );
  },

  _addChildren: function() {
    var that = this;
    return React.Children.map(this.props.children, function(child){
      if( child && child.type.displayName === "ChallengeCardImage" ) {
        return React.cloneElement(child, {onChangeCallback: that._adjustDescriptionHeight});
      }
      else if( child && child.type.displayName === "ChallengeCardDetails" ){
        return React.cloneElement(child, {maxLines: that.state.maxLines, onChange: that._adjustDescriptionHeight});
      }

      return child;
    });
  },

  _adjustDescriptionHeight : function(){
    var card = ReactDOM.findDOMNode(this.refs.card);
    var description = $(card).find(".description")[0];

    if(description) {
      var cardHeight = $(card).height();
      var imageHeight = $(card).find(".challenge-image ").outerHeight(true);
      var actionsHeight = $(card).find(".pt-card-actions").outerHeight(true);
      var titleHeight = $(card).find(".headline").outerHeight(true);
      var typeHeight = $(card).find(".challenge-metadata").outerHeight(true);
      var labelHeight = $(card).find(".challenge-label").outerHeight(true);

      var descriptionHeight = cardHeight - actionsHeight - titleHeight - typeHeight - imageHeight - labelHeight;

      var computedStyle = window.getComputedStyle(description);
      var lineHeight = parseInt(computedStyle.getPropertyValue("line-height"), 10);
      var maxLines = Math.floor(descriptionHeight / lineHeight);

      this.setState({maxLines: maxLines});
    }
  },

  _debouncedAdjustDescriptionHeight : function(){
    _.debounce(this._adjustDescriptionHeight, 300)();
  },

  _addWindowResizeEvent : function(){
    $(window).resize(this._debouncedAdjustDescriptionHeight);
  },

  _removeWindowResizeEvent: function(){
    $(window).off("resize", this._debouncedAdjustDescriptionHeight);
  }
});

ChallengeCard.Actions = Card.Actions;
ChallengeCard.Image = ChallengeCardImage;
ChallengeCard.Options = ChallengeCardOptions;

module.exports = ChallengeCard;



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/challenge_card.jsx